module.exports = __webpack_public_path__ + "img/hot_icon.71b85840.png";